import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, Tooltip } from "antd";
import EstoqueProducaoPage from "../pages/EstoqueProducaoPage";
import "./Form.css";
import "../pages/Pages.css";
import { getUsuario } from "../utils/LoginManager";

const { Column } = Table;
const ButtonGroup = Button.Group;

export default class ModalPadraoForm extends Component {
  state = {
    listaRegistros: [],
  };


  componentDidUpdate(propsAnterior) {

  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  onNovaVendaClick = (reg) => {
    this.props.onNovaVendaProducaoClick(reg);
  }



  render() {
    const { onFecharClick, visivel, telaModal } = this.props;
    const { listaRegistros, carregando } = this.state;

    // console.log('ModalPadraoForm.this.props', this.props);
    // console.log('ModalPadraoForm.this.state', this.state);

    return (
      <Modal
        title={null}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharClick}
        footer={null}
        width={"80%"}
        style={{ top: 10 }}
      >
        <div>
          <Row style={{ marginBottom: -20 }}>

            {telaModal === 'EstoqueProducao' ? (
              <EstoqueProducaoPage
                onNovaVendaClick={this.onNovaVendaClick}
                tipoTela="venda"
              />
            ) : null}

          </Row>
          <Row style={{ marginBottom: 20 }}>
            <div className="divider-page1" />
            <Col xs={24} style={{ marginTop: -10 }}>
              <Button
                htmlType="button"
                onClick={onFecharClick}
                className="botoesModalForm"
              >
                Fechar
              </Button>
            </Col>
          </Row>
        </div>
      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ModalPadraoForm.js